<template>
  <div :class="$style.frameGroup">
    <h2>{{ title }}</h2>
    <div :class="$style.frameContainer">
      <div :class="$style.formGroup">
        <div>What is your role at the flight school?</div>
        <HiloSelect
          :theme="'grey'"
          v-model="form.flightScheduleRoles"
          multi-select
          :options="flightSchoolRolesList"
          :placeholder="'Choose one...'"
          :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
        />
      </div>

      <div :class="$style.formGroup">
        <div>What areas of the flight school are you responsible for?</div>
        <HiloSelect
          :theme="'grey'"
          v-model="form.adminResponsibilities"
          multi-select
          :options="adminResponsibilitiesList"
          :placeholder="'Select all that apply...'"
          :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
        />
      </div>

      <div :class="$style.formGroup">
        <div>How do you handle challenges or setbacks?</div>
        <input
          type="text"
          v-model="form.handleChallenges"
          placeholder="Type your answer..."
        />
      </div>

      <div :class="$style.formGroup">
        <div>What tools or software do you currently use for management?</div>
        <HiloSelect
          :theme="'grey'"
          v-model="form.flightSchoolTools"
          multi-select
          :options="flightSchoolToolsList"
          :placeholder="'Select all that apply...'"
          :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
        />
      </div>

      <div :class="$style.formGroup">
        <div>
          What is one trait you possess that will make you a administrator?
        </div>
        <input
          type="text"
          v-model="form.personalityTrait"
          placeholder="Type your answer..."
        />
      </div>

      <div :class="$style.formGroup">
        <div>What is the highest level of education you have achieved?</div>
        <HiloSelect
          :theme="'grey'"
          v-model="form.educationLevelId"
          :options="educationLevelsList"
          :placeholder="'Choose one...'"
          :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
        />
      </div>

      <div :class="$style.formGroup">
        <div>What do you find the most challenging part of your role?</div>
        <input
          type="text"
          v-model="form.challengingPartOfRole"
          placeholder="Type your answer..."
        />
      </div>

      <div :class="$style.buttonContainer">
        <div :class="$style.nextButton" @click="handleNext">
          <b :class="$style.name">Next</b>
        </div>
        <div :class="$style.backButton" @click="$emit('onPrev')">
          <b :class="$style.name">Back</b>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import HiloSelect from "@/components/HiloComponents/HiloSelect.vue";
import AboutYouAPIService from "@/servicehandlers/AboutYouAPIService";
const aboutYouAPIService = new AboutYouAPIService();
export default defineComponent({
  props: {
    title: {
      type: String,
      required: true,
    },
    userId: {
      type: Number,
      required: true,
    },
  },
  components: {
    HiloSelect,
  },
  data() {
    return {
      form: {
        flightScheduleRoles: [],
        adminResponsibilities: [],
        handleChallenges: "",
        flightSchoolTools: [],
        personalityTrait: "",
        educationLevelId: "",
        challengingPartOfRole: "",
      },
      educationLevelsList: [],
      flightSchoolRolesList: [],
      adminResponsibilitiesList: [],
      flightSchoolToolsList: [],
      loading: false,
    };
  },
  mounted() {
    this.getAboutYouLists();
  },
  methods: {
    async getAboutYouLists() {
      try {
        [
          this.educationLevelsList,
          this.flightSchoolRolesList,
          this.adminResponsibilitiesList,
          this.flightSchoolToolsList,
        ] = await Promise.all([
          aboutYouAPIService.getEducationLevelsList(),
          aboutYouAPIService.getFlightSchoolRolesList(),
          aboutYouAPIService.getAdminResponsibilitiesList(),
          aboutYouAPIService.getFlightSchoolToolsList(),
        ]);
        this.flightSchoolRolesList = this.flightSchoolRolesList.filter(
          (role) => role.aboutYouAdmin,
        );
        this.flightSchoolToolsList = this.flightSchoolToolsList.filter(
          (role) => role.aboutYouAdmin,
        );
      } catch (error) {}
    },
    async handleNext() {
      try {
        this.loading = true;
        const aboutYouData = {
          ...this.form,
          userId: this.userId,
        };

        if (this.userId)
          await aboutYouAPIService.createOrUpdateAdmin(aboutYouData);
        this.$emit("onNext", { aboutYou: this.form });
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },
  },
});
</script>

<style module scoped>
.buttonContainer {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.buttonContainer div {
  align-self: stretch;
  border-radius: 10px;
  height: 50px;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  cursor: pointer;
  color: #fff;
  transition: 0.2s ease-in-out;
}

.buttonContainer div:hover {
  opacity: 0.8;
}

.nextButton {
  background-color: #3c78ff;
}

.backButton {
  background-color: #ccc;
}
.frameGroup {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.formGroup {
  display: flex;
  flex-direction: column;
  gap: 5px;
  position: relative;
}

.formGroup p {
  font-size: 16px;
}

.frameContainer {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 25px;
}
</style>
